import { useState } from 'react';
import { Link } from 'react-router-dom';

import { cn } from '@cobliteam/ui/utils';

import { type Location, locationUserPermission } from '@cobliteam/common-types';

import { Analytics } from '@cobliteam/analytics';

import { MenuItem, MenuItemType, PermissionsGate } from '@cobliteam/base-components';

export interface SidebarItemDropdownEntryProps {
  children: string | React.ReactNode;
  location: Location;
  active: boolean;
  menuItemClassName?: string;
  onClick?: () => void;
  onClickCapture?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  dataTest?: string;
}

export const SidebarItemDropdownEntry = ({ children, location, active, onClick, onClickCapture, dataTest }: SidebarItemDropdownEntryProps) => {
  const [hover, setHover] = useState(false);

  const handleClick = () => {
    Analytics.track('Sidebar Item Clicked', { page: location });

    if (onClick) {
      onClick();
    }
  };

  return (
    <PermissionsGate anyOfPermissions={locationUserPermission[location]}>
      <Link
        to={location}
        className={cn('hover: relative flex h-12 w-full items-center gap-5 no-underline', active ? 'pointer-events-none ' : '')}
        onMouseOver={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={handleClick}
        onClickCapture={onClickCapture}
        data-testid={dataTest}
      >
        <div className={cn('-translate-x-full absolute w-0.5 transform rounded bg-primary transition-all duration-300 ease-in-out', active ? 'h-full' : 'h-0')} />
        <MenuItem type={MenuItemType.LIGHT} active={hover || active} className='mx-5'>
          {children}
        </MenuItem>
      </Link>
    </PermissionsGate>
  );
};
